import { PaymentMethodListDropdownOption } from '../context'
import { ORDER_TYPES } from '../LabOrdersViewModel.constants'

export const getOrderTypes = () => {
  const enabledOrderTypes = Object.values(ORDER_TYPES).filter((orderType) => orderType.enabled)
  return enabledOrderTypes.map(({ text, value }) => {
    return { text: text, value: value, label: text }
  }) as PaymentMethodListDropdownOption[]
}
